// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ShoppingCartBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M28.151 7.039A1.501 1.501 0 0 0 27 6.5H7.25l-.534-2.947A2.5 2.5 0 0 0 4.256 1.5H2a1.5 1.5 0 0 0 0 3h1.839l3.113 17.125a3.5 3.5 0 0 0 .51 1.276 4 4 0 1 0 6.913 1.599h4.25a4 4 0 1 0 3.875-3H10.396a.5.5 0 0 1-.491-.41l-.29-1.59h13.897a3.5 3.5 0 0 0 3.444-2.875l1.52-8.357a1.5 1.5 0 0 0-.325-1.23ZM11.5 25.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm11 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM24 16.09a.5.5 0 0 1-.488.41H9.07l-1.272-7h17.405L24 16.09Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
